import { getHTML } from "../../services/helper";

interface IProps {
  linkClass?: string;
  isPageHeader?: boolean;
  content: {
    header?: string;
    description?: string;
  };
}

const Paragraph: React.FC<IProps> = (props: IProps) => {
  return (
    <div className={props.linkClass}>
      {props.content.header &&
        (props.isPageHeader ? (
          <>
            <div className="pageHeaderLine mx-auto"></div>
            <h1>{props.content.header}</h1>
          </>
        ) : (
          <h2>{props.content.header}</h2>
        ))}
      {props.content.description && (
        <p
          className={props.isPageHeader ? "pt-0" : ""}
          dangerouslySetInnerHTML={getHTML(props.content.description)}
        ></p>
      )}
    </div>
  );
};

export default Paragraph;
